// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2661":"372aab49","9268":"3401b028"}[chunkId] + ".chunk.css";
};